import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  view: 'login',
};

const authUiSlice = createSlice({
  name: 'authUi',
  initialState,
  reducers: {
    openLogin: (state) => {
      state.open = true;
      state.view = 'login';
    },
    openRegister: (state) => {
      state.open = true;
      state.view = 'register';
    },
    openForgot: (state) => {
      state.open = true;
      state.view = 'forgot';
    },
    openBalance: (state) => {
      state.open = true;
      state.view = 'balance';
    },
    openReset: (state, action) => {
      state.open = true;
      state.view = 'reset';
      state.otpUuid = action.payload?.otpUuid || null;
      state.phoneNumber = action.payload?.phoneNumber || null;
    },
    closeAuth: (state) => {
      state.open = false;
      state.otpUuid = null;
      state.phoneNumber = null;
    },
  },
});

export const { openLogin, openRegister, openForgot, openBalance, closeAuth, openReset } = authUiSlice.actions;

export default authUiSlice.reducer;
